module.exports = __webpack_public_path__ + "img/zhibo.b62a0a23.png";